baseApp.service('GeneralUtilsService', function () {
	return {
		toggleSelection: function(arr,item){
			var pos = arr.indexOf(item);
			if(pos >= 0){
				arr.splice(pos,1);
			}
			else {
				arr.push(item);
			}
		},
		getParams: function($location,decode,key){
			if(!key){
				key = "data";
			}
			var url = $location.absUrl();
			var pos = url.indexOf(key + "=");
			if(pos < 0){
				return null;
			}
			var end = url.indexOf("&",pos);
			var endIfEncoded = url.indexOf("%26",pos);
			if(endIfEncoded >= 0) {end = endIfEncoded}
			if(end < 0) {end = url.length}
			var data = url.substring(pos + (key.length + 1),end);
			if(decode){
				return decodeURIComponent(data);
			}
			else {
				return data;
			}
		},
		removeParam: function($location, key, reload){
			if(!key){
				key = "data";
			}
			var url = $location.absUrl();
			var pos = url.indexOf(key + "=");
			if(pos < 0){
				return;
			}

			window.location.href = url.substring(0,pos);
			if(reload){
				window.location.reload();
			}
		},
		getRandomId: function() {
			return  Math.floor((Math.random() * 100000000000000) + 1) * -1;
		},
		getTimeInMiliseconds: function(time) {
			while (time > 0 && time.toString().length < 13){
				time = time*10;
			}
			while (time > 0 && time.toString().length > 13){
				time = time/10;
			}
			return time;
		},
		convertHex: function(hex,opacity){
			hex = hex.replace('#','');
			var r = parseInt(hex.substring(0,2), 16);
			var g = parseInt(hex.substring(2,4), 16);
			var b = parseInt(hex.substring(4,6), 16);

			return 'rgba('+r+','+g+','+b+','+opacity/100+')';
		},

		/**
         * Adds all types of items to itemsToDelete according to the model and property name
         * Receives the model name, deleted items and the required key under itemsToDelete
         **/
		addItemsToDelete: function(model ,items, propertyName){
           if (items.length > 0) {
               if (!model.itemsToDelete) {
                      model.itemsToDelete = {};
                  }
              model.itemsToDelete[propertyName] = (model.itemsToDelete[propertyName] && model.itemsToDelete[propertyName].length > 0) ?
                                                                    items.concat(model.itemsToDelete[propertyName]) : items;
               }
       },

        cleanAmChartsFromScope: ($element) => {
            const chartIndexesToRemove = [];
            AmCharts.charts.forEach((chart, i) => {
                if ($(chart.chartDiv).parents($element[0]).length > 0) {
                    chart.clear();
                    chart = null;
                    chartIndexesToRemove.push(i);
                }
            });
            chartIndexesToRemove.forEach(i => AmCharts.charts.splice(i, 1));
        }
	}
});